class AssertionError extends Error {}

export function assert(condition: unknown, msg?: string): asserts condition {
  if (!condition) {
    throw new AssertionError(msg)
  }
}

export function assertExists<T>(value: T, msg?: string): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    throw new AssertionError(msg || 'The passed value does not exist')
  }
}

export function assertIsString(value: unknown): asserts value is string {
  if (typeof value !== 'string') {
    throw new AssertionError('Not a string!')
  }
}

export const hasValue = <T>(val: T | undefined | null): val is T => val !== undefined && val !== null
